import { functions, httpsCallable } from '@/firebase';

/**
 * Open a server-generated PDF using the same interaction for all Swan letters
 * and records. The blank tab is reserved during the user's click so popup
 * blockers do not discard the eventual preview.
 */
export async function openCallablePdf({
  functionName,
  payload,
  preparingTitle = 'Preparing document…',
  fallbackFilename = 'swan-document.pdf',
}) {
  const previewWindow = window.open('', '_blank');
  if (previewWindow) {
    previewWindow.opener = null;
    previewWindow.document.title = preparingTitle;
    previewWindow.document.body.textContent = preparingTitle;
  }

  let data;
  try {
    const getPdf = httpsCallable(functions, functionName);
    ({ data } = await getPdf(payload));
  } catch (error) {
    previewWindow?.close();
    throw error;
  }

  const { filename, mimeType, contentBase64 } = data || {};
  if (!contentBase64) {
    previewWindow?.close();
    throw new Error('No PDF returned');
  }

  const byteChars = atob(contentBase64);
  const bytes = new Uint8Array(byteChars.length);
  for (let index = 0; index < byteChars.length; index += 1) {
    bytes[index] = byteChars.charCodeAt(index);
  }
  const blob = new Blob([bytes], { type: mimeType || 'application/pdf' });
  const url = URL.createObjectURL(blob);

  if (previewWindow && !previewWindow.closed) {
    previewWindow.location.replace(url);
  } else {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename || fallbackFilename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  }

  setTimeout(() => URL.revokeObjectURL(url), 60000);
  return { filename };
}
